export function Underline({
  classNames,
}: {
  classNames?: string;
}): JSX.Element {
  return (
    <div className={`absolute bottom-0 left-0 right-0 ${classNames}`}></div>
  );
}
